import React, { useState, useEffect } from 'react'
import { AreaItems, Card, ContentChildren, ContentIcon, DynamicItem } from "./styles"
import { IoCheckmark, IoClose } from 'react-icons/io5'
import { FaRegTrashCan } from 'react-icons/fa6'

export function CustomItemCard({
  click,
  dynamicClick = false,
  children,
  titleWeight,
  maxWidth,
  minWidth,
  margin,
  width,
  display,
  flexDirection,
  alignItems,
  justifyContent,
  active,
  initIcon,
  onConfirm,
  onCancel,
  backgroundColor,
  borderRadius,
  isOverflow = true
}) {
  const [open, setOpen] = useState(dynamicClick)

  const handleInitClick = e => {
    e.stopPropagation()
    setOpen(true)
  }

  const handleConfirm = e => {
    e.stopPropagation()
    onConfirm && onConfirm()
    setOpen(false)
  }

  const handleCancel = e => {
    e.stopPropagation()
    onCancel && onCancel()
    setOpen(false)
  }


  useEffect(() => {
    setOpen(dynamicClick)
  }, [dynamicClick])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.card-container')) {
        setOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <Card
      className="card-container"
      $width={width}
      $maxWidth={maxWidth}
      $minWidth={minWidth}
      $margin={margin}
      $active={active}
      $backgroundColor={backgroundColor}
      $borderRadius={borderRadius}
      $isOverflow={isOverflow}
      onClick={click}
    >
      <ContentChildren>
        <AreaItems
          $titleWeight={titleWeight}
          $display={display}
          $flexDirection={flexDirection}
          $alignItems={alignItems}
          $justifyContent={justifyContent}
          $shift={open ? '80px' : '0'}
        >
          {children}
        </AreaItems>

        {initIcon && !open &&
          <FaRegTrashCan size={window.screen.width < 500 ? 30 : 18} color="#f87171" onClick={handleInitClick} />
        }
      </ContentChildren>

      <DynamicItem $dynamicClick={open}>
        <ContentIcon>
          <IoCheckmark size={window.screen.width < 500 ? 30 : 18} color="#0db60d" onClick={handleConfirm} />
        </ContentIcon>

        <ContentIcon>
          <IoClose size={window.screen.width < 500 ? 30 : 18} color="#f87171" onClick={handleCancel} />
        </ContentIcon>
      </DynamicItem>
    </Card>
  )
}